<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <!-- {{ caja }} -->
  <div v-if="userIsRecepcion()">
    <!-- {{ authStore.user }} -->
    <!-- {{ props.arqueo }} -->
    <v-form @submit.prevent="handleSubmit">
      <!-- Add print-only header -->
      <!-- <div class="print-only-header">
        <div class="text-center mt-0 mb-0">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex">
              <v-img
                :src="hotelLogo"
                max-height="47"
                :alt="hotelName"
                class="mr-2 hide-on-print"
              ></v-img>
              <img
                :src="hotelLogo"
                :alt="hotelName"
                class="print-only-img mr-2"
                style="max-height: 47px"
              />
            </div>
            <div class="d-flex align-center mr-6">
              <div class="mr-6">Turno {{ caja.turno || '' }}</div>
              <div>
                <span>{{ formatDate(caja.fecha) || '' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <v-container>
        <v-row v-if="authStore.user?.turno == ''">
          <v-col cols="3" md="2">
            <v-text-field
              v-model="caja.fecha"
              label="Fecha"
              type="date"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="3" md="2">
            <v-select
              label="Turno"
              :items="turnos"
              item-title="text"
              item-value="value"
              v-model="caja.turno"
            ></v-select>
          </v-col>
          <v-col cols="3" md="2">
            <v-switch
              v-model="caja.cambio_turno"
              label="Cambio de turno"
              :true-value="1"
              :false-value="0"
              color="info"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row v-if="authStore.user?.turno !== ''">
          <v-col cols="12" md="2">
            <v-text-field
              v-model="caja.turno"
              label="Turno"
              required
              readonly
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-text-field v-model="caja.hotel" label="Hotel"></v-text-field>
          </v-col> -->
          <v-col cols="12" md="2">
            <v-text-field
              v-model="caja.fecha"
              label="Fecha"
              type="date"
              required
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="totalEntradas"
              label="Entradas"
              type="number"
              required
              bg-color="#a5d7ff"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="totalSalidas"
              label="Salidas"
              type="number"
              required
              bg-color="#f5ada8"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="totalEntradasMenosSalidas"
              label="Cuadre"
              type="number"
              required
              bg-color="#9edba0"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-switch
              v-model="caja.cambio_turno"
              label="Cambio de turno"
              :true-value="1"
              :false-value="0"
              color="info"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="[key] in monedasBilletes"
            :key="key"
            cols="12"
            sm="3"
            md="2"
          >
            <v-text-field
              v-model.number="caja[key]"
              :label="calcular(key)"
              type="number"
              :onchange="handleTotal"
              min="0"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="[key] in monedasMonedas"
            :key="key"
            cols="12"
            sm="3"
            md="2"
          >
            <v-text-field
              v-model.number="caja[key]"
              :label="calcular(key)"
              type="text"
              :onchange="handleTotal"
              min="0"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <!-- <v-row v-if="authStore.user?.turno !== ''"> -->
          <v-col cols="12" md="2" sd="2">
            <v-text-field
              v-model.number="caja.total_caja"
              label="Total caja €"
              readonly
              min="0"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="2" sd="2">
            <v-text-field
              v-model.number="caja.total_inicial"
              label="Caja anterior €"
              readonly
              min="0"
              ></v-text-field>
            </v-col> -->
          <v-col cols="12" md="2" sd="2">
            <v-text-field
              v-model.number="totalCuadre"
              label="Total cuadre €"
              readonly
              min="0"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" sd="2">
            <v-text-field
              :model-value="descuadre ? Number(descuadre).toFixed(2) : '0.00'"
              label="Descuadre €"
              readonly
              min="0"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" md="10" sd="10">
            <v-textarea
              v-model="caja.observaciones"
              label="Observaciones"
            ></v-textarea>
          </v-col>
          <v-col cols="2" class="text-center mt-13">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ caja.id && !props.arqueo ? 'Actualizar' : 'Crear' }} Caja
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <!-- Add print confirmation dialog -->
    <ConfirmationDialog
      v-model="showPrintDialog"
      title="Imprimir Caja"
      content="¿Desea imprimir la caja?"
      cancel-button-text="No"
      confirm-button-text="Sí, imprimir"
      cancel-button-color="grey darken-1"
      confirm-button-color="primary"
      @cancel="handleCancelPrint"
      @confirm="handleConfirmPrint"
    />
    <ConfirmationDialog
      v-model="showDialog"
      title="Cambio de turno"
      content="Has cerrado la caja y ha cambiado el turno, ¿quieres que cerremos la sesión?"
      cancel-button-text="No"
      confirm-button-text="Cerrar la sesión"
      cancel-button-color="blue darken-1"
      confirm-button-color="red darken-1"
      @cancel="handleCancelDialog"
      @confirm="handleConfirmDialog"
    />
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
      {{ snackbar.text }}
    </v-snackbar>
  </div>

  <!-- Agregar una sección específica para impresión que estará oculta durante la vista normal -->
  <div class="print-only-view">
    <div class="print-header">
      <div class="header-content">
        <div class="hotel-logo">
          <img :src="hotelLogo" :alt="hotelName" style="max-height: 47px" />
        </div>
        <div class="print-metadata">
          <div class="metadata-content">
            <span>Turno {{ caja.turno }}</span>
            <span class="date-separator">|</span>
            <span>{{ formatDate(caja.fecha) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Fila de Entradas/Salidas/Cuadre -->
    <div class="print-row-group summary-row">
      <!-- Agregar el cambio de turno a la izquierda -->
      <div class="print-cell cambio-turno">
        <div class="print-label">Cambio de turno</div>
        <div class="">
          {{ caja.cambio_turno ? 'SI' : 'NO' }}
        </div>
      </div>
      <div class="print-cell">
        <div class="print-label">Entradas</div>
        <div class="print-value">{{ totalEntradas }}</div>
      </div>
      <div class="print-cell">
        <div class="print-label">Salidas</div>
        <div class="print-value">{{ totalSalidas }}</div>
      </div>
      <div class="print-cell">
        <div class="print-label">Cuadre</div>
        <div class="print-value">{{ totalEntradasMenosSalidas }}</div>
      </div>
    </div>

    <!-- Fila de billetes (500€ a 5€) -->
    <div class="print-row-group money-row">
      <div class="money-cell" v-for="[key] in monedasBilletes" :key="key">
        <div class="money-label">{{ monedas[key] }}€</div>
        <div class="money-value">{{ caja[key] || 0 }}</div>
      </div>
    </div>

    <!-- Fila de monedas (2€ a 0.01€) -->
    <div class="print-row-group money-row">
      <div class="money-cell" v-for="[key] in monedasMonedas" :key="key">
        <div class="money-label">{{ monedas[key] }}€</div>
        <div class="money-value">{{ caja[key] || 0 }}</div>
      </div>
    </div>

    <!-- Fila de totales -->
    <div class="print-row-group totals-row">
      <div class="print-cell">
        <div class="print-label">Total Caja</div>
        <div class="print-value">{{ formatCurrency(caja.total_caja) }}</div>
      </div>
      <div class="print-cell">
        <div class="print-label">Total Cuadre</div>
        <div class="print-value">{{ formatCurrency(totalCuadre) }}</div>
      </div>
      <div class="print-cell">
        <div class="print-label">Descuadre</div>
        <div class="print-value">{{ formatCurrency(descuadre) }}</div>
      </div>
    </div>

    <!-- Observaciones si existen -->
    <div class="print-observations" v-if="caja.observaciones">
      <div class="print-label">Observaciones:</div>
      <div class="print-value">{{ caja.observaciones }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { useDashboardStore } from '@/stores/dashboard'
import { useCajaStore } from '@/stores/cajaStore'
import {
  focusFirstInput,
  formatCurrency,
  userIsRecepcion
} from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'
import { getToken, getUser } from '@/utils/tokenStorage'
import ConfirmationDialog from '../common/ConfirmationDialog.vue'
// import router from '@/router'
import { useAuthStore } from '@/stores/authStore'
const authStore = useAuthStore()
const dashboardStore = useDashboardStore()

const cajaStore = useCajaStore()
// const userIsRecepcionValue = userIsRecepcion()
const props = defineProps({
  itemId: {
    type: Number,
    default: null
  },
  arqueo: {
    type: Boolean,
    default: false
  }
})
const turnos = ref([
  { text: 'Turno A', value: 'A' },
  { text: 'Turno B', value: 'B' },
  { text: 'Turno C', value: 'C' },
  { text: 'Turno D', value: 'D' }
])

const showDialog = ref(false)
const showPrintDialog = ref(false)

const caja = reactive({
  turno: '',
  total_caja: 0,
  total_inicial: 0,
  // hotel: '',
  fecha: new Date().toISOString().substr(0, 10),
  m500: null,
  m200: null,
  m100: null,
  m50: null,
  m20: null,
  m10: null,
  m5: null,
  m2: null,
  m1: null,
  m050: null,
  m020: null,
  m010: null,
  m005: null,
  m002: null,
  m001: null,
  observaciones: ''
})

const descuadre = ref(0)
const monedas = {
  m500: '500',
  m200: '200',
  m100: '100',
  m50: '50',
  m20: '20',
  m10: '10',
  m5: '5',
  m2: '2',
  m1: '1',
  m050: '0.50',
  m020: '0.20',
  m010: '0.10',
  m005: '0.05',
  m002: '0.02',
  m001: '0.01'
}

const loading = ref(false)
const totalEntradas = ref(0)
const totalSalidas = ref(0)
const totalCuadre = ref(0)
const totalEntradasMenosSalidas = ref(0)
const emit = defineEmits(['saved'])

const monedasBilletes = computed(() => {
  // eslint-disable-next-line no-unused-vars
  return Object.entries(monedas).filter(([key, value]) => parseInt(value) >= 5)
})
const monedasMonedas = computed(() => {
  // eslint-disable-next-line no-unused-vars
  return Object.entries(monedas).filter(
    // eslint-disable-next-line no-unused-vars
    ([key, value]) => parseFloat(value) < 5
  )
})

onMounted(async () => {
  // await dashboardStore.fetchDashboardDataTurno()
  await dashboardStore.fetchDashboardData()
  // totalEntradas.value = dashboardStore.entradasTurno
  // totalSalidas.value = dashboardStore.salidasTurno
  // totalEntradasMenosSalidas.value = totalEntradas.value - totalSalidas.value

  totalEntradas.value = parseFloat(dashboardStore.entradas).toFixed(2)
  totalSalidas.value = parseFloat(dashboardStore.salidas).toFixed(2)
  totalEntradasMenosSalidas.value = Number(
    (parseFloat(totalEntradas.value) - parseFloat(totalSalidas.value)).toFixed(
      2
    )
  )

  if (props.itemId) {
    loading.value = true
    try {
      const cajaData = await cajaStore.getCaja(props.itemId)
      // console.log('ONMOUNTED ', props.itemId, cajaData)

      Object.assign(caja, cajaData)
      // console.log('>>caja.total_inicial', caja.total_inicial)
      handleTotal()
    } catch (error) {
      console.error('Error al cargar caja:', error)
    } finally {
      loading.value = false
    }
  } else {
    // buscar datos de la última caja
    const infoCaja = await cajaStore.getLastCajaInfo()

    if (infoCaja) {
      const user = getUser()
      console.log(user)
      caja.turno = user.turno
      caja.total_inicial =
        infoCaja.lastCaja == null ? 0 : infoCaja.lastCaja.total_caja
    }
  }
  totalCuadre.value = (
    parseFloat(caja.total_inicial) +
    dashboardStore.entradasTotalCuadre -
    dashboardStore.salidasTotalCuadre
  ).toFixed(2)
  // Add focus to first enabled input after form is loaded
  console.log('totalCuadre', totalCuadre.value)
  console.log(
    'dashboardStore.entradasTotalCuadre',
    dashboardStore.entradasTotalCuadre
  )
  console.log(
    'dashboardStore.salidasTotalCuadre',
    dashboardStore.salidasTotalCuadre
  )
  focusFirstInput()
})

const calcular = (key) => {
  // console.log('KEY:', key, caja[key], parseFloat(monedas[key]))
  if (parseFloat(caja[key]) == 0) {
    return `${monedas[key]} €`
  }
  const space = `\u200B \u200B \u200B \u200B \u200B`
  return `${monedas[key]} € ${space} (${formatCurrency(caja[key] * parseFloat(monedas[key]))} €)`
}

const handleTotal = () => {
  let totalCaja = 0
  Object.keys(monedas).forEach((key) => {
    totalCaja += caja[key] * parseFloat(monedas[key])
  })
  totalCaja = totalCaja.toFixed(2)
  caja.total_caja = totalCaja
  // TotalCuadre = Caja anterior + Cobros Efectivo (E) - Pagos recepcion (E) - Buzones(G)
  // Descuadre = Caja anterior - TotalCuadre
  descuadre.value = parseFloat(totalCaja) - parseFloat(totalCuadre.value)
}

const snackbar = reactive({
  show: false,
  text: '',
  color: 'error'
})

const handleSubmit = async () => {
  if (props.arqueo && !caja.turno) {
    snackbar.text = 'Por favor seleccione un turno'
    snackbar.show = true
    return
  }

  loading.value = true
  try {
    // let response
    const token = getToken()
    if (caja.id && !props.arqueo) {
      console.log('UPDATE CAJA')
      caja.diferencia = descuadre.value
      caja.arqueo = true
      await cajaStore.updateCaja(caja, token)
    } else if (props.arqueo) {
      caja.arqueo = true
      caja.diferencia = descuadre.value
      console.log('CLOSE CAJA')
      await cajaStore.closeCaja(caja, token)
      // Primero mostramos el diálogo de impresión
      showPrintDialog.value = true
      // El evento saved se emitirá después de la respuesta del diálogo
    } else {
      console.log('create caja')
      await cajaStore.createCaja({ ...caja }, token)
      showPrintDialog.value = true
    }
  } catch (error) {
    console.error('Error al guardar caja:', error)
  } finally {
    loading.value = false
  }
}

// const handleCancelDialog = () => {
//   console.log('Diálogo cancelado')
//   // Lógica adicional para manejar la cancelación
//   emit('saved', caja) // Emitimos el evento después de imprimir
// }

// const handleConfirmDialog = () => {
//   console.log('Confirmado, cerrando sesión')
//   router.push('/login')
// }

// Funciones de manejo de impresión
const handleCancelPrint = () => {
  showPrintDialog.value = false
  console.log('handleCancelDialog', caja)
  emit('saved', caja) // Emitimos el evento después de imprimir
}

const handleConfirmPrint = () => {
  showPrintDialog.value = false
  printCaja()
  emit('saved', caja) // Emitimos el evento después de imprimir
  // if (caja.value.cambio_turno && !caja.value.arqueo) {
  //   showDialog.value = true
  // }
}

const printCaja = () => {
  const style = document.createElement('style')
  style.type = 'text/css'
  style.innerHTML = `
    @media print {
      body * {
        visibility: hidden !important;
      }
      .print-only-view, .print-only-view * {
        visibility: visible !important;
      }
      .print-only-view {
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  `

  try {
    document.head.appendChild(style)
    window.print()
    setTimeout(() => {
      document.head.removeChild(style)
    }, 1000)
  } catch (error) {
    console.error('Error in printCaja:', error)
  }
}

// Add computed properties for hotel logo
const hotelLogo = computed(() => {
  const baseUrl = window.location.origin
  return authStore.user?.hotel === 'B'
    ? `${baseUrl}/assets/barcelona.png`
    : `${baseUrl}/assets/palacete.png`
})

const hotelName = computed(() => {
  switch (authStore.user?.hotel) {
    case 'B':
      return 'Barcelona'
    case 'P':
      return 'Palacete'
    default:
      return 'N/A'
  }
})

const formatDate = (dateStr) => {
  const date = new Date(dateStr)
  return date.toLocaleDateString()
}
</script>

<style scoped>
/* Hide the header and print-only image during normal view */
.print-only-header {
  position: absolute;
  top: -9999px;
  left: -9999px;
  visibility: hidden;
}

.print-only-img {
  display: none;
}

/* @media print {
  .print-only-header {
    padding-top: 0px !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    visibility: visible !important;
    width: 100% !important;
    margin-top: 0px !important;
  }

  .summary-row,
  .totals-row,
  .cambio-turno .print-label {
    font-size: 18px !important;
  }

  .print-cell.cambio-turno {
    margin-left: 40px !important;
    width: fit-content !important;
  }

  .money-label,
  .money-value {
    font-size: 18px !important;
  }

  .hide-on-print {
    display: none !important;
  }

  .print-only-img {
    display: block !important;
    visibility: visible !important;
    max-height: 47px !important;
    width: auto !important;
  }
} */

/* Estilos específicos para impresión */
.print-only-view {
  display: none; /* Oculto en vista normal */
}

@media print {
  /* Ocultar el formulario normal */
  .v-form {
    display: none !important;
  }

  .summary-row,
  .totals-row,
  .cambio-turno .print-label {
    font-size: 18px !important;
  }

  .print-cell.cambio-turno {
    margin-left: 40px !important;
    width: fit-content !important;
  }

  .money-label,
  .money-value {
    font-size: 18px !important;
  }

  /* Mostrar la vista de impresión */
  .print-only-view {
    display: block !important;
    padding: 0 20px;
    margin: 0 !important;
    top: 50px;
    /* font-size: 14px; */
    width: 100%;
    max-width: none;
    margin: 0;
    position: absolute;
  }

  .print-header {
    margin-top: 0 !important; /* Reducimos también el margen inferior del header */
    margin-bottom: 20px !important; /* Reducimos también el margen inferior del header */
    padding: 10px 0;
    border-bottom: 1px solid #000;
    padding-bottom: 10px;
    position: relative;
    min-height: 55px; /* Reducimos un poco la altura mínima */
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 15px;
  }

  .hotel-logo {
    flex: 0 0 auto;
    padding-left: 10px;
    padding-top: 0;
    margin-top: 0;
  }

  .hotel-logo img {
    max-height: 47px;
    width: auto;
    visibility: visible !important;
    display: block;
    margin-top: 0;
  }

  .print-metadata {
    display: flex;
    align-items: flex-end;
    padding-right: 10px;
    font-size: 18px !important;
    position: absolute; /* Posicionamiento absoluto */
    right: 25px; /* Mantener a la derecha */
    bottom: 10px; /* Posicionar cerca del borde inferior */
  }

  .metadata-content {
    font-size: 18px;
    display: flex;
    gap: 10px;
  }

  .date-separator {
    color: #666;
  }

  .print-row-group.summary-row {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    padding: 0 15px; /* Más espacio en los laterales para las filas de contenido */
    margin-right: 10px;
    padding-bottom: 20px;
    border-bottom: 2px solid #6e6e6e;
  }

  .print-row-group.summary-row .print-cell {
    flex: 0 0 auto;
    /* width: 120px; */
    /* margin-left: 30px; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .print-row-group.totals-row {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    padding: 10px 25px; /* Más espacio en los laterales para las filas de contenido */
    margin-top: 20px !important;
    margin-right: 10px;
    border-bottom: 2px solid #6e6e6e;
    border-top: 2px solid #6e6e6e;
  }
  .print-row-group.totals-row .print-cell {
    flex: 0 0 auto;
    width: 120px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .money-row {
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    gap: 20px;
    padding: 10px 0;
  }

  .money-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 65px;
    min-width: 65px;
    max-width: 65px;
    border: 1px solid #999;
    padding: 5px 4px;
    border-radius: 4px;
  }

  .money-cell .money-label {
    font-weight: bold;
    margin-bottom: 8px;
    color: #666;
    text-align: center;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
    width: 100%;
    font-size: 13px;
  }

  .money-cell .money-value {
    font-size: 14px;
    text-align: center;
    width: 100%;
    padding-top: 2px;
  }

  .totals-row {
    margin-top: 20px;
    /* border-top: 2px solid #000;
    border-bottom: 2px solid #000; */
    padding: 15px 0;
    justify-content: flex-end;
  }

  .totals-row .print-cell {
    margin-left: 30px;
  }

  /* Asegurar que los valores monetarios estén alineados */
  .print-value::after {
    content: ' €';
    display: inline-block;
  }

  .print-observations {
    margin-top: 20px;
    padding-top: 10px;
  }

  /* Ajustes de página */
  @page {
    size: A4;
    margin-right: 8mm; /* Reducir el margen derecho de la página */
    margin-top: 1mm !important; /* Reducido a 5mm */
  }

  /* Asegurar que todo el contenido es visible */
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  html {
    margin: 0 !important;
    padding: 0 !important;
  }

  .print-only-view,
  .print-only-view *,
  .print-header,
  .print-header * {
    visibility: visible !important;
  }

  /* Asegurar que el logo sea visible durante la impresión */
  .print-only-view .hotel-logo img {
    visibility: visible !important;
    display: block !important;
  }

  .summary-row {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    margin-bottom: 15px;
    padding: 10px 25px; /* Mantener consistencia en los márgenes */
    gap: 30px;
  }

  .cambio-turno {
    margin-right: auto;
    padding-left: 10px;
    width: 100px;
    border: 1px solid #000;
    padding: 5px;
  }

  .cambio-turno .print-label {
    font-size: 12px;
    white-space: nowrap;
    margin-bottom: 3px;
  }

  .cambio-turno .print-value {
    font-size: 14px;
    font-weight: bold;
  }

  .print-cell:not(.cambio-turno) {
    text-align: center;
    min-width: 120px;
  }
}

/* Asegurarnos de que no haya márgenes del body o html
body {
  margin-top: 0 !important;
  padding-top: 0 !important;
} */

.print-only-view * {
  margin-top: 0;
}
</style>
